import modelmain from "./349_MainSeat.glb";
import ribs from "./349_Ribs.glb";
import logomain from "./349_MainLogo.glb";
import logohexa from "./349_HexaLogo.glb";
import leftBolt from "./349_SideLogoLeftBolt.glb";
import leftEnjoy from "./349_SideLogoLeftEnjoy.glb";
import rightEnjoy from "./349_SideLogoRightEnjoy.glb";
import rightBolt from "./349_SideLogoRightBolt.glb";
import number from "./349_Number.glb";

// This is one of the eBike models (AKA Surron)
// Link to test
// /?type=ebike1&subtype=ribbed&test=yes

const modelParts = {
  main: modelmain,
  ribs: ribs,
  logoMain: logomain,
  logoHexa: logohexa,
  number: number,
};

const leftLogoParts = {
  bolt: leftBolt,
  enjoyMfg: leftEnjoy,
};
const rightLogoParts = {
  bolt: rightBolt,
  enjoyMfg: rightEnjoy,
};

const leftLogoCoords = {
  bolt: {
    // position: [[0.105, 0, 0.13]],
    position: [0.105, 0, 0.13],
    rotation: [1.724, 0.407, -1.461],
    scale: 0.272,
  },
  enjoyMfg: {
    // position: [0.122, -0.068, 0.217],
    position: [0.103, 0, 0.143],
    rotation: [1.718, 0.406, -1.459],
    scale: 0.468,
  },
};
const rightLogoCoords = {
  bolt: {
    position: [-0.109, -0.001, 0.132],
    rotation: [1.691, -0.439, 1.608],
    scale: 0.272,
  },
  enjoyMfg: {
    position: [-0.111, 0, 0.151],
    rotation: [1.716, -0.438, 1.618],
    scale: 0.468,
  },
};
const numberCoords = {
  modelPosition: [0, 0.0865, -0.212],
  modelRotation: [0, 0, 0],
  textPosition: [-0.03, -0.18, 0],
  textRotation: [Math.PI / -2, 0, 0],
  textScale: 0.325,
  decalSize: 0.08,
  letterSpacing: 0.03,
  aspectRatio: [3, 1],
};

export {
  modelParts,
  leftLogoCoords,
  leftLogoParts,
  rightLogoCoords,
  rightLogoParts,
  numberCoords,
};
